import Transformer from '@/transformers/transformer'
import staffTransformer from '@/transformers/catalogs/staff'
import moment from 'moment'
import 'moment/locale/es-mx'

/**
 * @class MatrixCustomer
 * Authorized customer
 * @author Jose Luis R
 */

export default class AuthorizationMatrix extends Transformer {
  static fetch({ id, is_active: isActive, add_date: addDate, last_modified: lastModified, customer, zone = {}, budget_amount_before: budgetAmountBefore, budget_amount_after: budgetAmountAfter, gnp_matrix_start: gnpMatrixStart, need_authorization_before_repair: needAuthBefore, need_authorization_after_repair: needAuthAfter, repair_without_authorization: repairWithoutAuthorization, authorization_gnp: authorizationGNP, file_type: filetype, authorization = [], ...matrix }) {
    return {
      id,
      isActive,
      addDate,
      lastModified,
      customer,
      zone: zone.slug,
      zoneName: zone.name,
      budgetAmountBefore,
      budgetAmountAfter,
      repairWithoutAuthorization,
      authorizationGNP,
      gnpMatrixStart,
      needAuthBefore,
      needAuthAfter: matrix.need_authorization_after_repair,
      filetype,

      authorization: authorization.map((s) => s.id),
      authorizeStaff: authorization ? staffTransformer.fetchCollection(authorization) : []
    }
  }
  static send(matrix) {
    return {
      customer: matrix.customer,
      zone: matrix.zone,
      authorization: matrix.authorization,
      need_authorization_before_repair: matrix.needAuthBefore,
      need_authorization_after_repair: matrix.needAuthAfter,
      budget_amount_before: matrix.budgetAmountBefore,
      budget_amount_after: matrix.budgetAmountAfter,
      file_type: matrix.filetype,
      repair_without_authorization: matrix.repairWithoutAuthorization,
      authorization_gnp: matrix.authorizationGNP,
      gnp_matrix_start: matrix.gnpMatrixStart ? moment(matrix.gnpMatrixStart) : null

    }
  }
}
